import { ValidationErrors } from 'final-form';
import { get } from 'lodash';
import { Rule } from '~common/validator/validation-rules';

export const validate = <T>(input: T | null | undefined, rules: Rule<T>[]): string | undefined => {
  let errorMessage: string | undefined;
  rules.forEach((rule) => {
    if (rule.handler(input) === false) {
      errorMessage = rule.message();
    }
  });

  return errorMessage;
};

export const validateArrayField = <T>(
  values: T,
  key: string,
  rules: Rule<T>[],
  index = 0,
): ValidationErrors => {
  const errors: ValidationErrors = {};

  rules.forEach((rule) => {
    const value = get(values, `${key}.[${index}].value`);
    if (rule.handler(value) === false) {
      errors[key] = [{ value: rule.message() }];
    }
  });

  return errors;
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/common/src/validator/index.ts